<script>
import SearchLoop from "./excerpts/SearchLoop.vue";
import he from "he";
export default {
  name: "FiltersCpts",
  emits: ["handleClick", "filterElementsByKeyword"],
  components: {
    SearchLoop,
  },
  props: {
    filters: {
      type: Array,
      default: () => [],
    },
    type_de_filtre: {
      type: String,
      default: "",
    },
    dataJson: {
      type: Object,
      default: () => {},
    },
  },

  data() {
    return {
      userEntry: "",
    };
  },

  methods: {
    decode(string) {
      return he.decode(string);
    },
    resetUserEntry() {
      this.userEntry = "";
    },
  },
};
</script>

<template>
  <div class="filters">
    <!-- Filtre avec boutons -->
    <template v-if="this.type_de_filtre === 'boutons'">
      <div
        class="buttons"
        v-for="(filter, index) in filters"
        :key="filter.taxonomy"
      >
        <div
          :class="filter.isAllButtonToggled ? 'active' : ''"
          @click="
            () => {
              $emit('handleClick', 'all', filter);
            }
          "
          class="button button-all-filters"
        >
          <span>
            {{ this.$props.dataJson[`texte_tous_les_filtres_${index + 1}`] }}
          </span>
        </div>
        <div
          @click="$emit('handleClick', term.name, filter)"
          :class="term.active ? 'active' : ''"
          class="button"
          v-for="term in filter.terms"
          :key="term.id"
          v-show="term.count > 0"
        >
          <span>
            {{ decode(term.name) }}
          </span>
        </div>
      </div>
    </template>
    <!-- Champ pour filtrer les résultats de la page -->
    <div
      v-if="dataJson.champs_texte_pour_affiner"
      class="text-filter-container"
    >
      <SearchLoop />
      <input
        v-if="dataJson.champs_texte_pour_affiner"
        type="text"
        v-model="userEntry"
        @input="$emit('filterElementsByKeyword', userEntry)"
        class="filter-input"
        placeholder="RECHERCHE"
        ref="searchInput"
      />
    </div>
  </div>
</template>

<style lang="scss" scoped>
.selects-container {
  color: black;
}
</style>
